export const formatTo12Hour = (hour: number) => {
  const h = parseInt(hour.toString(), 10);
  const period = h < 12 ? 'AM' : 'PM';
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12} ${period}`;
};

export const formatHour = (hour: any) => {
  const h = hour % 12 || 12;
  const suffix = hour >= 12 ? 'PM' : 'AM';
  return `${h}:00 ${suffix}`;
};

export const getDayWithOrdinal = (day: number) => {
  if (day >= 11 && day <= 13) return `${day}th`;
  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
};

export const isValidTimeZone = (tz: any) => {
  if (!tz || typeof tz !== 'string' || !tz.trim()) return false;
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz.trim() });
    return true;
  } catch (e) {
    return false;
  }
};

export const formatWeeklyMonthly = (date: Date, timeZone: string) => {
  const weekday = date.toLocaleString('en-US', { ...(isValidTimeZone(timeZone) ? { timeZone: timeZone.trim() } : {}), weekday: 'long' });
  const month = date.toLocaleString('en-US', { ...(isValidTimeZone(timeZone) ? { timeZone: timeZone.trim() } : {}), month: 'short' });

  const dayNumber = Number(date.toLocaleString('en-US', { ...(isValidTimeZone(timeZone) ? { timeZone: timeZone.trim() } : {}), day: 'numeric' }));
  const dayWithOrdinal = getDayWithOrdinal(dayNumber);

  const year = date.toLocaleString('en-US', { ...(isValidTimeZone(timeZone) ? { timeZone: timeZone.trim() } : {}), year: 'numeric' });

  const time = date.toLocaleString('en-US', {
    ...(isValidTimeZone(timeZone) ? { timeZone: timeZone.trim() } : {}),
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });

  return `${weekday} ${month} ${dayWithOrdinal}, ${year} at ${time}`;
};

export const getScanMessage = (row: any) => {
  const next = new Date(row?.nextUpdateTime);
  const timeZone = row?.timeZone || 'UTC';

  // const local = next.toLocaleString('en-US', {
  //   ...(isValidTimeZone(timeZone) ? { timeZone: timeZone.trim() } : {}),
  //   weekday: 'long',
  //   month: 'short',
  //   day: 'numeric',
  //   year: 'numeric',
  //   hour: 'numeric',
  //   minute: '2-digit',
  //   hour12: true
  // });

  if (row?.refresh_frequency === 'every') {
    return `Your next scan is scheduled for ${formatWeeklyMonthly(next, timeZone)}.`;
  }

  if (row?.refresh_frequency === 'daily') {
    return `This scan runs every day at ${formatHour(row.refresh_hour)}.`;
  }

  if (row?.refresh_frequency === 'weekly') {
    return `Your next scan is scheduled for ${formatWeeklyMonthly(next, timeZone)}.`;
  }

  if (row?.refresh_frequency === 'monthly') {
    return `Your next scan is scheduled for ${formatWeeklyMonthly(next, timeZone)}.`;
  }

  return '';
};

export const recalculateGridPositions = (newCenter: any, originalGridData: any) => {
  if (!originalGridData || originalGridData.length === 0) return [];

  const centerIndex = Math.floor(originalGridData.length / 2);
  const originalCenter = originalGridData[centerIndex];

  const latOffset = newCenter.lat - originalCenter.lat;
  const lngOffset = newCenter.lng - originalCenter.lng;

  return originalGridData.map((pos: any, index: number) => ({
    ...pos,
    lat: pos.lat + latOffset,
    lng: pos.lng + lngOffset
  }));
};

export const getCurrentCenterPosition = (centerPosition: any) => {
  return centerPosition;
};

export const formattedDate2 = () => {
  let frmtdDate = new Date()
    .toLocaleString('en-US', {
      day: 'numeric',
      month: '2-digit',
      year: 'numeric'
    })
    .replace(/,|:|\s/g, '-')
    .replace(/-+/g, '-');
  return frmtdDate;
};

export const getAdjustedZoomLevel = (
  gridMultiplier: any,
  radiusMile: any,
  selectShape: any,
  convertIsAdminManager: boolean,
  adminSelectedBusiness: any,
  selectedBusiness: any,
  getZoomLevel: (params: any) => number
) => {
  const mapWidthPx = window.innerWidth - 100;
  const grid_multiplier = parseInt(
    (gridMultiplier ||
      (selectShape === 'Rectangular' ? '3x3 grid (9 Credits)' : '1 layer (7 Credits)')
    ).match(/\d+/)?.[0] || '0',
    10
  );
  const lat = convertIsAdminManager
    ? adminSelectedBusiness?.location?.coordinates?.[1]
    : selectedBusiness?.location?.coordinates?.[1];
  return getZoomLevel({
    grid_multiplier: grid_multiplier,
    radiusMile,
    mapWidthPx,
    lat
  });
};
